export const GeneralTypes = {
    SET_LANGUAGE: 'general/SET_LANGUAGE'
  }
  
  export const setLanguage = (payload) => ({
    type: GeneralTypes.SET_LANGUAGE,
    payload
  })
  